import 'css-chunk:../../src/components/icons/tick/index.module.scss';export default {
  "tick": "_tick_1kmus_1"
};